import { render, staticRenderFns } from "./FormDocumentacion_Empresa.vue?vue&type=template&id=74339f44&"
import script from "./FormDocumentacion_Empresa.vue?vue&type=script&lang=js&"
export * from "./FormDocumentacion_Empresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\simulador_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74339f44')) {
      api.createRecord('74339f44', component.options)
    } else {
      api.reload('74339f44', component.options)
    }
    module.hot.accept("./FormDocumentacion_Empresa.vue?vue&type=template&id=74339f44&", function () {
      api.rerender('74339f44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Formularios/Documentacion/FormDocumentacion_Empresa.vue"
export default component.exports